// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-header {
  font-family: Arial, sans-serif;
  position: relative;
  z-index: 997;
  color: var(--header-text-color, #333333);
}

/* Background layer */
.react-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--header-bg-color, #ffffff);
  background-image: var(--header-bg-image, none);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 0;
  pointer-events: none;
}

/* Overlay layer */
.react-header::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--header-bg-color, #ffffff);
  opacity: var(--header-bg-opacity, 0);
  z-index: 1;
  pointer-events: none;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 10;
}

/* Top Bar */
.header__top-bar {
  background: transparent;
  border-bottom: 1px solid rgba(224, 224, 224, 0.3);
  font-size: 14px;
  padding: 8px 0;
  color: var(--header-topbar-text, #333333);
  position: relative;
  z-index: 1000;
}

.header__top-bar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: visible;
}

.header__top-right {
  display: flex;
  align-items: center;
  gap: 20px;
  overflow: visible;
}

.header__phone {
  color: var(--header-topbar-text, #333);
  font-weight: 500;
  text-decoration: none;
}

.header__phone:hover {
  color: var(--header-link-hover, #007bff);
}

.header__account {
  color: var(--header-topbar-text, #333);
  text-decoration: none;
  font-size: 14px;
  font-weight: 400;
}

.header__account:hover {
  color: var(--header-link-hover, #007bff);
}

/* Localization */
.header__localization {
  position: relative;
  z-index: 1100;
  overflow: visible;
}

.localization__dropdown {
  position: relative;
  overflow: visible;
}

.localization__menu.is-open {
  display: block;
}

.localization__trigger {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--header-topbar-text, #333);
  font-size: 14px;
  padding: 4px 8px;
}

.localization__menu {
  display: none;
  position: fixed;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 180px;
  z-index: 10001;
  pointer-events: auto;
}

.localization__menu::before {
  content: '';
  position: absolute;
  top: -5px;
  left: 0;
  right: 0;
  height: 5px;
  background: transparent;
}

.localization__section {
  padding: 12px;
  border-bottom: 1px solid #f0f0f0;
}

.localization__section:last-child {
  border-bottom: none;
}

.localization__section h4 {
  margin: 0 0 8px 0;
  font-size: 12px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
}

.localization__section button {
  display: block;
  width: 100%;
  background: none;
  border: none;
  padding: 4px 8px;
  text-align: left;
  cursor: pointer;
  font-size: 14px;
  border-radius: 3px;
}

.localization__section button:hover,
.localization__section button.active {
  background: #f0f0f0;
  color: var(--header-link-hover, #007bff);
}

/* Main Header */
.header__main {
  background: transparent;
  border-bottom: 1px solid #e0e0e0;
  padding: 12px 0;
  position: relative;
  z-index: 10;
}

.header__content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  position: relative;
  z-index: 100;
}

.header__logo {
  flex-shrink: 0;
}

.header__logo-link {
  text-decoration: none;
  display: block;
  transition: opacity 0.3s ease;
}

.header__logo-link:hover {
  opacity: 0.8;
}

.header__logo h1 {
  margin: 0;
  padding: 0;
  line-height: 1;
}

.header__logo img,
.logo__image {
  height: var(--logo-height, 140px);
  width: auto;
  max-width: 300px;
  object-fit: contain;
}

.logo__text {
  font-size: 28px;
  font-weight: bold;
  text-decoration: none;
  color: var(--header-text-color, #333);
}

.logo__big {
  color: #007bff;
}

.logo__fish {
  color: #333;
}

/* Navigation */
.header__nav {
  flex: 1;
  display: flex;
  justify-content: center;
}

.nav__list {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 30px;
}

.nav__item {
  position: relative;
}

.nav__link {
  color: var(--header-text-color, #333);
  text-decoration: none;
  font-weight: 500;
  font-size: 14px;
  text-transform: uppercase;
  transition: color 0.3s ease;
  display: flex;
  align-items: center;
  gap: 5px;
}

.nav__link:hover,
.nav__link.active {
  color: var(--header-link-hover, #007bff);
}

.dropdown-arrow {
  font-size: 10px;
  transition: transform 0.3s ease;
}

.nav__item--dropdown:hover .dropdown-arrow {
  transform: rotate(180deg);
}

/* Catalog Dropdown - Широкое меню как на макете */
.catalog-dropdown {
  position: fixed;
  top: 120px;
  left: 0;
  right: 0;
  background: white;
  border-top: 1px solid #e0e0e0;
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  margin-top: 0;
  animation: fadeInDown 0.3s ease-out;
  width: 100vw;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.catalog-dropdown__content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

.catalog-dropdown__title {
  display: none;
}

.catalog-dropdown__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
}

.catalog-dropdown__item {
  margin: 0;
}

.catalog-dropdown__link {
  display: block;
  text-decoration: none;
  color: #333;
  transition: all 0.3s ease;
  border-radius: 8px;
  overflow: hidden;
  background: white;
  border: 1px solid #f0f0f0;
}

.catalog-dropdown__link:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  border-color: #e0e0e0;
}

.catalog-dropdown__image {
  width: 100%;
  height: 180px;
  object-fit: cover;
  display: block;
}

.catalog-dropdown__info {
  padding: 20px;
}

.catalog-dropdown__name {
  font-weight: 600;
  font-size: 18px;
  text-transform: uppercase;
  margin-bottom: 12px;
  color: #333;
}

.catalog-dropdown__subcategories {
  list-style: none;
  margin: 0;
  padding: 0;
}

.catalog-dropdown__subcategory {
  margin-bottom: 8px;
}

.catalog-dropdown__subcategory a {
  color: #666;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s ease;
}

.catalog-dropdown__subcategory a:hover {
  color: #007bff;
}

.catalog-dropdown__footer {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
  text-align: center;
}

.catalog-dropdown__all {
  display: inline-block;
  background: #333;
  color: white;
  text-decoration: none;
  font-weight: 500;
  font-size: 14px;
  text-transform: uppercase;
  padding: 12px 30px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.catalog-dropdown__all:hover {
  background: #007bff;
  transform: translateY(-1px);
}

/* Cart */
.header__cart {
  flex-shrink: 0;
  position: relative;
  z-index: 50;
}

.cart__link {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--header-text-color, #333);
  text-decoration: none;
  font-size: 14px;
  text-transform: uppercase;
  font-weight: 500;
}

.cart__count {
  color: var(--header-link-hover, #007bff);
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .header__top-bar {
    display: block;
  }

  .header__nav {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border-top: 1px solid #e0e0e0;
    z-index: 999;
  }

  .header__nav.is-open {
    display: block;
  }

  .nav__list {
    flex-direction: column;
    padding: 20px;
    gap: 15px;
  }

  .header__content {
    gap: 10px;
  }

  .cart__text {
    display: none;
  }

  .logo__image {
    height: 80px;
  }

  .logo__text {
    font-size: 20px;
  }

  /* Mobile catalog dropdown */
  .catalog-dropdown {
    position: fixed;
    top: 80px;
    left: 0;
    right: 0;
    width: 100vw;
    background: white;
    border-top: 1px solid #e0e0e0;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    max-height: 80vh;
    overflow-y: auto;
  }

  .catalog-dropdown__content {
    padding: 20px 15px;
  }

  .catalog-dropdown__list {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .catalog-dropdown__link {
    display: flex;
    align-items: center;
    gap: 15px;
    padding: 15px;
    border-radius: 12px;
    border: 1px solid #f0f0f0;
    background: #fafafa;
  }

  .catalog-dropdown__image {
    width: 80px;
    height: 80px;
    border-radius: 8px;
    flex-shrink: 0;
  }

  .catalog-dropdown__info {
    padding: 0;
    flex: 1;
  }

  .catalog-dropdown__name {
    font-size: 16px;
    margin-bottom: 8px;
  }

  .catalog-dropdown__subcategories {
    display: block;
  }

  .catalog-dropdown__subcategory {
    display: inline-block;
    margin-right: 10px;
    margin-bottom: 4px;
  }

  .catalog-dropdown__subcategory a {
    font-size: 12px;
    color: #007bff;
    background: rgba(0, 123, 255, 0.1);
    padding: 2px 8px;
    border-radius: 12px;
  }

  .catalog-dropdown__footer {
    margin-top: 20px;
    padding-top: 15px;
  }

  .catalog-dropdown__all {
    padding: 10px 20px;
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .catalog-dropdown__list {
    gap: 15px;
  }

  .catalog-dropdown__content {
    padding: 15px 10px;
  }

  .catalog-dropdown__image {
    width: 60px;
    height: 60px;
  }

  .catalog-dropdown__name {
    font-size: 14px;
  }

  .catalog-dropdown__subcategory a {
    font-size: 11px;
    padding: 1px 6px;
  }
}

/* Mobile Menu Styles */
.header__mobile-toggle {
  display: none;
  flex-direction: column;
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  gap: 4px;
}

.header__mobile-toggle span {
  width: 25px;
  height: 3px;
  background: #333;
  transition: all 0.3s ease;
}

.header__mobile-toggle.active span:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}

.header__mobile-toggle.active span:nth-child(2) {
  opacity: 0;
}

.header__mobile-toggle.active span:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

.header__mobile-menu {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: white;
  z-index: 9999;
  overflow-y: auto;
}

.mobile-menu__close {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 50px;
  height: 100vh;
  background: rgba(0, 0, 0, 0.1);
  border: none;
  cursor: pointer;
  font-size: 24px;
  color: #333;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 20px;
  z-index: 10000;
}

.mobile-menu__close:hover {
  background: rgba(0, 0, 0, 0.2);
}

.mobile-menu__content {
  padding: 20px;
  padding-right: 80px; /* Space for close button */
}

.mobile-menu__top {
  padding: 20px 0;
  border-bottom: 1px solid #eee;
  margin-bottom: 30px;
}

.mobile-menu__phone {
  margin-bottom: 20px;
}

.mobile-menu__phone a {
  color: #333;
  font-weight: 500;
  text-decoration: none;
  font-size: 16px;
}

.mobile-menu__localization {
  position: relative;
}

.mobile-localization__dropdown {
  position: relative;
}

.mobile-localization__trigger {
  background: #f8f8f8;
  border: 1px solid #ddd;
  padding: 12px 16px;
  border-radius: 5px;
  cursor: pointer;
  width: 100%;
  text-align: left;
  font-size: 14px;
}

.mobile-localization__menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  margin-top: 5px;
  z-index: 1000;
}

.mobile-localization__section {
  padding: 15px;
}

.mobile-localization__section h4 {
  margin: 0 0 10px 0;
  font-size: 14px;
  color: #666;
}

.mobile-localization__section button {
  display: block;
  width: 100%;
  padding: 8px 12px;
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
  border-radius: 3px;
  margin-bottom: 5px;
  transition: background 0.3s ease;
}

.mobile-localization__section button:hover,
.mobile-localization__section button.active {
  background: #f0f8ff;
  color: #007bff;
}

.mobile-menu__nav {
  margin-top: 20px;
}

.mobile-nav__list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.mobile-nav__item {
  border-bottom: 1px solid #f0f0f0;
}

.mobile-nav__link {
  display: block;
  padding: 20px 0;
  color: #333;
  text-decoration: none;
  font-size: 18px;
  font-weight: 600;
  transition: color 0.3s ease;
}

.mobile-nav__link:hover,
.mobile-nav__link.active {
  color: #007bff;
}

@media (max-width: 768px) {
  .header__main {
    padding: 15px 0;
  }

  .header__main .container {
    padding: 0 15px;
  }

  /* Make top bar responsive */
  .header__top-bar {
    padding: 5px 0;
    font-size: 12px;
  }

  .header__top-bar .container {
    padding: 0 15px;
  }

  .header__phone {
    font-size: 12px;
  }

  .header__localization {
    gap: 10px;
  }

  .localization__button {
    padding: 2px 6px;
    font-size: 11px;
  }

  .header__nav,
  .cart__text {
    display: none;
  }

  .header__mobile-toggle {
    display: flex;
  }

  .header__cart svg {
    width: 24px;
    height: 24px;
  }

  .cart__count {
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iDAAiD;EACjD,8CAA8C;EAC9C,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,UAAU;EACV,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iDAAiD;EACjD,oCAAoC;EACpC,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,uBAAuB;EACvB,iDAAiD;EACjD,eAAe;EACf,cAAc;EACd,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,sCAAsC;EACtC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA,gBAAgB;AAChB;EACE,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,UAAU;EACV,cAAc;AAChB;;AAEA;;EAEE,iCAAiC;EACjC,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA,eAAe;AACf;EACE,OAAO;EACP,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kDAAkD;AAClD;EACE,eAAe;EACf,UAAU;EACV,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,yCAAyC;EACzC,aAAa;EACb,aAAa;EACb,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,SAAS;AACT;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,sBAAsB;AACtB;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,6BAA6B;IAC7B,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA,4BAA4B;EAC5B;IACE,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,iBAAiB;IACjB,6BAA6B;IAC7B,yCAAyC;IACzC,aAAa;IACb,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,OAAO;EACT;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,kCAAkC;IAClC,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,2BAA2B;AAClD;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,4BAA4B;EAC5B;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".react-header {\n  font-family: Arial, sans-serif;\n  position: relative;\n  z-index: 997;\n  color: var(--header-text-color, #333333);\n}\n\n/* Background layer */\n.react-header::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: var(--header-bg-color, #ffffff);\n  background-image: var(--header-bg-image, none);\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  z-index: 0;\n  pointer-events: none;\n}\n\n/* Overlay layer */\n.react-header::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: var(--header-bg-color, #ffffff);\n  opacity: var(--header-bg-opacity, 0);\n  z-index: 1;\n  pointer-events: none;\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n  position: relative;\n  z-index: 10;\n}\n\n/* Top Bar */\n.header__top-bar {\n  background: transparent;\n  border-bottom: 1px solid rgba(224, 224, 224, 0.3);\n  font-size: 14px;\n  padding: 8px 0;\n  color: var(--header-topbar-text, #333333);\n  position: relative;\n  z-index: 1000;\n}\n\n.header__top-bar .container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  overflow: visible;\n}\n\n.header__top-right {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  overflow: visible;\n}\n\n.header__phone {\n  color: var(--header-topbar-text, #333);\n  font-weight: 500;\n  text-decoration: none;\n}\n\n.header__phone:hover {\n  color: var(--header-link-hover, #007bff);\n}\n\n.header__account {\n  color: var(--header-topbar-text, #333);\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.header__account:hover {\n  color: var(--header-link-hover, #007bff);\n}\n\n/* Localization */\n.header__localization {\n  position: relative;\n  z-index: 1100;\n  overflow: visible;\n}\n\n.localization__dropdown {\n  position: relative;\n  overflow: visible;\n}\n\n.localization__menu.is-open {\n  display: block;\n}\n\n.localization__trigger {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--header-topbar-text, #333);\n  font-size: 14px;\n  padding: 4px 8px;\n}\n\n.localization__menu {\n  display: none;\n  position: fixed;\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  min-width: 180px;\n  z-index: 10001;\n  pointer-events: auto;\n}\n\n.localization__menu::before {\n  content: '';\n  position: absolute;\n  top: -5px;\n  left: 0;\n  right: 0;\n  height: 5px;\n  background: transparent;\n}\n\n.localization__section {\n  padding: 12px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.localization__section:last-child {\n  border-bottom: none;\n}\n\n.localization__section h4 {\n  margin: 0 0 8px 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: #666;\n  text-transform: uppercase;\n}\n\n.localization__section button {\n  display: block;\n  width: 100%;\n  background: none;\n  border: none;\n  padding: 4px 8px;\n  text-align: left;\n  cursor: pointer;\n  font-size: 14px;\n  border-radius: 3px;\n}\n\n.localization__section button:hover,\n.localization__section button.active {\n  background: #f0f0f0;\n  color: var(--header-link-hover, #007bff);\n}\n\n/* Main Header */\n.header__main {\n  background: transparent;\n  border-bottom: 1px solid #e0e0e0;\n  padding: 12px 0;\n  position: relative;\n  z-index: 10;\n}\n\n.header__content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  position: relative;\n  z-index: 100;\n}\n\n.header__logo {\n  flex-shrink: 0;\n}\n\n.header__logo-link {\n  text-decoration: none;\n  display: block;\n  transition: opacity 0.3s ease;\n}\n\n.header__logo-link:hover {\n  opacity: 0.8;\n}\n\n.header__logo h1 {\n  margin: 0;\n  padding: 0;\n  line-height: 1;\n}\n\n.header__logo img,\n.logo__image {\n  height: var(--logo-height, 140px);\n  width: auto;\n  max-width: 300px;\n  object-fit: contain;\n}\n\n.logo__text {\n  font-size: 28px;\n  font-weight: bold;\n  text-decoration: none;\n  color: var(--header-text-color, #333);\n}\n\n.logo__big {\n  color: #007bff;\n}\n\n.logo__fish {\n  color: #333;\n}\n\n/* Navigation */\n.header__nav {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n}\n\n.nav__list {\n  display: flex;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  gap: 30px;\n}\n\n.nav__item {\n  position: relative;\n}\n\n.nav__link {\n  color: var(--header-text-color, #333);\n  text-decoration: none;\n  font-weight: 500;\n  font-size: 14px;\n  text-transform: uppercase;\n  transition: color 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.nav__link:hover,\n.nav__link.active {\n  color: var(--header-link-hover, #007bff);\n}\n\n.dropdown-arrow {\n  font-size: 10px;\n  transition: transform 0.3s ease;\n}\n\n.nav__item--dropdown:hover .dropdown-arrow {\n  transform: rotate(180deg);\n}\n\n/* Catalog Dropdown - Широкое меню как на макете */\n.catalog-dropdown {\n  position: fixed;\n  top: 120px;\n  left: 0;\n  right: 0;\n  background: white;\n  border-top: 1px solid #e0e0e0;\n  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  margin-top: 0;\n  animation: fadeInDown 0.3s ease-out;\n  width: 100vw;\n}\n\n@keyframes fadeInDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.catalog-dropdown__content {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 40px 20px;\n}\n\n.catalog-dropdown__title {\n  display: none;\n}\n\n.catalog-dropdown__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 30px;\n}\n\n.catalog-dropdown__item {\n  margin: 0;\n}\n\n.catalog-dropdown__link {\n  display: block;\n  text-decoration: none;\n  color: #333;\n  transition: all 0.3s ease;\n  border-radius: 8px;\n  overflow: hidden;\n  background: white;\n  border: 1px solid #f0f0f0;\n}\n\n.catalog-dropdown__link:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);\n  border-color: #e0e0e0;\n}\n\n.catalog-dropdown__image {\n  width: 100%;\n  height: 180px;\n  object-fit: cover;\n  display: block;\n}\n\n.catalog-dropdown__info {\n  padding: 20px;\n}\n\n.catalog-dropdown__name {\n  font-weight: 600;\n  font-size: 18px;\n  text-transform: uppercase;\n  margin-bottom: 12px;\n  color: #333;\n}\n\n.catalog-dropdown__subcategories {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.catalog-dropdown__subcategory {\n  margin-bottom: 8px;\n}\n\n.catalog-dropdown__subcategory a {\n  color: #666;\n  text-decoration: none;\n  font-size: 14px;\n  transition: color 0.3s ease;\n}\n\n.catalog-dropdown__subcategory a:hover {\n  color: #007bff;\n}\n\n.catalog-dropdown__footer {\n  margin-top: 30px;\n  padding-top: 20px;\n  border-top: 1px solid #f0f0f0;\n  text-align: center;\n}\n\n.catalog-dropdown__all {\n  display: inline-block;\n  background: #333;\n  color: white;\n  text-decoration: none;\n  font-weight: 500;\n  font-size: 14px;\n  text-transform: uppercase;\n  padding: 12px 30px;\n  border-radius: 4px;\n  transition: all 0.3s ease;\n}\n\n.catalog-dropdown__all:hover {\n  background: #007bff;\n  transform: translateY(-1px);\n}\n\n/* Cart */\n.header__cart {\n  flex-shrink: 0;\n  position: relative;\n  z-index: 50;\n}\n\n.cart__link {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--header-text-color, #333);\n  text-decoration: none;\n  font-size: 14px;\n  text-transform: uppercase;\n  font-weight: 500;\n}\n\n.cart__count {\n  color: var(--header-link-hover, #007bff);\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .header__top-bar {\n    display: block;\n  }\n\n  .header__nav {\n    display: none;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    background: white;\n    border-top: 1px solid #e0e0e0;\n    z-index: 999;\n  }\n\n  .header__nav.is-open {\n    display: block;\n  }\n\n  .nav__list {\n    flex-direction: column;\n    padding: 20px;\n    gap: 15px;\n  }\n\n  .header__content {\n    gap: 10px;\n  }\n\n  .cart__text {\n    display: none;\n  }\n\n  .logo__image {\n    height: 80px;\n  }\n\n  .logo__text {\n    font-size: 20px;\n  }\n\n  /* Mobile catalog dropdown */\n  .catalog-dropdown {\n    position: fixed;\n    top: 80px;\n    left: 0;\n    right: 0;\n    width: 100vw;\n    background: white;\n    border-top: 1px solid #e0e0e0;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    z-index: 1000;\n    max-height: 80vh;\n    overflow-y: auto;\n  }\n\n  .catalog-dropdown__content {\n    padding: 20px 15px;\n  }\n\n  .catalog-dropdown__list {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  .catalog-dropdown__link {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    padding: 15px;\n    border-radius: 12px;\n    border: 1px solid #f0f0f0;\n    background: #fafafa;\n  }\n\n  .catalog-dropdown__image {\n    width: 80px;\n    height: 80px;\n    border-radius: 8px;\n    flex-shrink: 0;\n  }\n\n  .catalog-dropdown__info {\n    padding: 0;\n    flex: 1;\n  }\n\n  .catalog-dropdown__name {\n    font-size: 16px;\n    margin-bottom: 8px;\n  }\n\n  .catalog-dropdown__subcategories {\n    display: block;\n  }\n\n  .catalog-dropdown__subcategory {\n    display: inline-block;\n    margin-right: 10px;\n    margin-bottom: 4px;\n  }\n\n  .catalog-dropdown__subcategory a {\n    font-size: 12px;\n    color: #007bff;\n    background: rgba(0, 123, 255, 0.1);\n    padding: 2px 8px;\n    border-radius: 12px;\n  }\n\n  .catalog-dropdown__footer {\n    margin-top: 20px;\n    padding-top: 15px;\n  }\n\n  .catalog-dropdown__all {\n    padding: 10px 20px;\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 480px) {\n  .catalog-dropdown__list {\n    gap: 15px;\n  }\n\n  .catalog-dropdown__content {\n    padding: 15px 10px;\n  }\n\n  .catalog-dropdown__image {\n    width: 60px;\n    height: 60px;\n  }\n\n  .catalog-dropdown__name {\n    font-size: 14px;\n  }\n\n  .catalog-dropdown__subcategory a {\n    font-size: 11px;\n    padding: 1px 6px;\n  }\n}\n\n/* Mobile Menu Styles */\n.header__mobile-toggle {\n  display: none;\n  flex-direction: column;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 5px;\n  gap: 4px;\n}\n\n.header__mobile-toggle span {\n  width: 25px;\n  height: 3px;\n  background: #333;\n  transition: all 0.3s ease;\n}\n\n.header__mobile-toggle.active span:nth-child(1) {\n  transform: translateY(7px) rotate(45deg);\n}\n\n.header__mobile-toggle.active span:nth-child(2) {\n  opacity: 0;\n}\n\n.header__mobile-toggle.active span:nth-child(3) {\n  transform: translateY(-7px) rotate(-45deg);\n}\n\n.header__mobile-menu {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  background: white;\n  z-index: 9999;\n  overflow-y: auto;\n}\n\n.mobile-menu__close {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  width: 50px;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.1);\n  border: none;\n  cursor: pointer;\n  font-size: 24px;\n  color: #333;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding-top: 20px;\n  z-index: 10000;\n}\n\n.mobile-menu__close:hover {\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.mobile-menu__content {\n  padding: 20px;\n  padding-right: 80px; /* Space for close button */\n}\n\n.mobile-menu__top {\n  padding: 20px 0;\n  border-bottom: 1px solid #eee;\n  margin-bottom: 30px;\n}\n\n.mobile-menu__phone {\n  margin-bottom: 20px;\n}\n\n.mobile-menu__phone a {\n  color: #333;\n  font-weight: 500;\n  text-decoration: none;\n  font-size: 16px;\n}\n\n.mobile-menu__localization {\n  position: relative;\n}\n\n.mobile-localization__dropdown {\n  position: relative;\n}\n\n.mobile-localization__trigger {\n  background: #f8f8f8;\n  border: 1px solid #ddd;\n  padding: 12px 16px;\n  border-radius: 5px;\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n  font-size: 14px;\n}\n\n.mobile-localization__menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: white;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n  margin-top: 5px;\n  z-index: 1000;\n}\n\n.mobile-localization__section {\n  padding: 15px;\n}\n\n.mobile-localization__section h4 {\n  margin: 0 0 10px 0;\n  font-size: 14px;\n  color: #666;\n}\n\n.mobile-localization__section button {\n  display: block;\n  width: 100%;\n  padding: 8px 12px;\n  border: none;\n  background: none;\n  text-align: left;\n  cursor: pointer;\n  border-radius: 3px;\n  margin-bottom: 5px;\n  transition: background 0.3s ease;\n}\n\n.mobile-localization__section button:hover,\n.mobile-localization__section button.active {\n  background: #f0f8ff;\n  color: #007bff;\n}\n\n.mobile-menu__nav {\n  margin-top: 20px;\n}\n\n.mobile-nav__list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.mobile-nav__item {\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.mobile-nav__link {\n  display: block;\n  padding: 20px 0;\n  color: #333;\n  text-decoration: none;\n  font-size: 18px;\n  font-weight: 600;\n  transition: color 0.3s ease;\n}\n\n.mobile-nav__link:hover,\n.mobile-nav__link.active {\n  color: #007bff;\n}\n\n@media (max-width: 768px) {\n  .header__main {\n    padding: 15px 0;\n  }\n\n  .header__main .container {\n    padding: 0 15px;\n  }\n\n  /* Make top bar responsive */\n  .header__top-bar {\n    padding: 5px 0;\n    font-size: 12px;\n  }\n\n  .header__top-bar .container {\n    padding: 0 15px;\n  }\n\n  .header__phone {\n    font-size: 12px;\n  }\n\n  .header__localization {\n    gap: 10px;\n  }\n\n  .localization__button {\n    padding: 2px 6px;\n    font-size: 11px;\n  }\n\n  .header__nav,\n  .cart__text {\n    display: none;\n  }\n\n  .header__mobile-toggle {\n    display: flex;\n  }\n\n  .header__cart svg {\n    width: 24px;\n    height: 24px;\n  }\n\n  .cart__count {\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
